import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "002_repair_payroll_numbering",
  version: "1.0.1",
  sql: `
UPDATE \`core_numbering_series\`
SET
  \`prefix\` = 'PAY-{YYYY}-{MM}-#####',
  \`reset_every\` = 'monthly',
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE
  \`module\` = 'hr'
  AND \`doctype\` = 'payroll_entry'
  AND (
    \`prefix\` != 'PAY-{YYYY}-{MM}-#####'
    OR \`reset_every\` != 'monthly'
  );
  `.trim(),
};
